import Audio from '~/Audio';
import Colors from '~/constants/Colors';
import { logError } from '~/logger';
import text from '~/text';
import { validateBagEquipMove, validateBagSlotMove } from 'dt-common/validators/gameItemMove';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { ItemLocationInput } from 'dt-common/generated/graphql-types';
import messages, { GameStateStoreMessage } from '~/flux/stores/GameStateStore/messages';
import mutationEquipBagToHeroBagSlot from '~/graphql/game-items/mutationEquipBagToHeroBagSlot';

export default async function equipBagToHeroBagSlot(
  {
    playerId,
    setInventoryAndHeroRoster,
    emit,
  }: {
    playerId: string;
    setInventoryAndHeroRoster: (data: { inventory?: unknown; hero_roster?: unknown }) => void;
    emit: (event: GameStateStoreMessage) => void;
  },
  action: {
    from: ItemLocationInput;
    to: ItemLocationInput;
    game_item: { slot?: string | null; type: string };
  }
) {
  const slotCheck = validateBagSlotMove(action.game_item, action.to);
  if (!slotCheck.ok) {
    window.$addMessageLogMessage(text(slotCheck.errorKey), Colors.RED);
    return;
  }

  const check = validateBagEquipMove(action.from, action.to);
  if (!check.ok) {
    window.$addMessageLogMessage(text(check.errorKey), Colors.RED);
    return;
  }

  try {
    const data = await mutationEquipBagToHeroBagSlot({
      playerId,
      from: action.from,
      to: action.to,
    });

    setInventoryAndHeroRoster({
      ...(data.inventory != null && { inventory: data.inventory }),
      ...(data.heroRoster != null && { hero_roster: data.heroRoster }),
    });

    emit(messages.EQUIPMENT_CHANGE);
    Audio.play('equipment_storage');
  } catch (err) {
    const errorKey = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    if (typeof errorKey === 'string' && text(errorKey)) {
      window.$addMessageLogMessage(text(errorKey), Colors.RED);
    } else {
      window.$addMessageLogMessage(text('server_error'), Colors.RED);
      logError(err, {
        module: 'GameStateStore',
        func: 'equipBagToHeroBagSlot',
        playerId,
        action: JSON.stringify(action),
      });
    }
  }
}
